export function riUpfrontType(value) {
  switch (value) {
    case 'Standard_1_No':
      return 'Standard 1 year No upfront';
    case 'Standard_1_Partial':
      return 'Standard 1 year Partial upfront';
    case 'Standard_1_Full':
      return 'Standard 1 year Full upfront';
    case 'Standard_3_No':
      return 'Standard 3 years No upfront';
    case 'Standard_3_Partial':
      return 'Standard 3 years Partial upfront';
    case 'Standard_3_Full':
      return 'Standard 3 years Full upfront';
    case 'Standard_1_Medium':
      return 'Standard 1 year Medium';
    case 'Standard_1_Heavy':
      return 'Standard 1 year Heavy';
    case 'Standard_3_Medium':
      return 'Standard 3 years Medium';
    case 'Standard_3_Heavy':
      return 'Standard 3 years Heavy';
    case 'Convertible_1_No':
      return 'Convertible 1 year No upfront';
    case 'Convertible_1_Partial':
      return 'Convertible 1 year Partial upfront';
    case 'Convertible_1_Full':
      return 'Convertible 1 year Full upfront';
    case 'Convertible_3_No':
      return 'Convertible 3 years No upfront';
    case 'Convertible_3_Partial':
      return 'Convertible 3 years Partial upfront';
    case 'Convertible_3_Full':
      return 'Convertible 3 years Full upfront';
    case 'Convertible_1_Medium':
      return 'Convertible 1 year Medium';
    case 'Convertible_1_Heavy':
      return 'Convertible 1 year Heavy';
    case 'Convertible_3_Medium':
      return 'Convertible 3 years Medium';
    case 'Convertible_3_Heavy':
      return 'Convertible 3 years Heavy';
    default:
      return value;
  }
}

export function regionAws(value) {
  switch (value) {
    case 'APS3':
      return 'Asia Pacific (Mumbai)';
    case 'APN2':
      return 'Asia Pacific (Seoul)';
    case 'APS1':
      return 'Asia Pacific (Singapore)';
    case 'APS2':
      return 'Asia Pacific (Sydney)';
    case 'APN1':
      return 'Asia Pacific (Tokyo)';
    case 'UGW1':
      return 'AWS GovCloud (US)';
    case 'CAN1':
      return 'Canada (Central)';
    case 'EUC1':
      return 'EU (Frankfurt)';
    case 'EUW1': //"EU" on csv
      return 'EU (Ireland)';
    case 'EUW2':
      return 'EU (London)';
    case 'EUW3':
      return 'EU (Paris)';
    case 'SAE1':
      return 'South America (Sao Paulo)';
    case 'USE1':
      return 'US East (N. Virginia)'; //"" on csv (empty)
    case 'USE2':
      return 'US East (Ohio)';
    case 'USW1':
      return 'US West (N. California)';
    case 'USW2':
      return 'US West (Oregon)';

    case 'ap-south-1':
      return 'Asia Pacific (Mumbai)';
    case 'ap-northeast-2':
      return 'Asia Pacific (Seoul)';
    case 'ap-southeast-1':
      return 'Asia Pacific (Singapore)';
    case 'ap-southeast-2':
      return 'Asia Pacific (Sydney)';
    case 'ap-northeast-1':
      return 'Asia Pacific (Tokyo)';
    case 'ca-central-1':
      return 'Canada (Central)';
    case 'eu-central-1':
      return 'EU (Frankfurt)';
    case 'eu-west-1':
      return 'EU (Ireland)';
    case 'eu-west-2':
      return 'EU (London)';
    case 'eu-west-3':
      return 'EU (Paris)';
    case 'sa-east-1':
      return 'South America (Sao Paulo)';
    case 'us-east-1':
      return 'US East (N. Virginia)';
    case 'us-east-2':
      return 'US East (Ohio)';
    case 'us-west-1':
      return 'US West (N. California)';
    case 'us-west-2':
      return 'US West (Oregon)';
    default:
      return value;
  }
}

export function serviceNameAws(name, short) {
  switch (name) {
    case 'AmazonEC2':
      if (short) {
        return 'EC2';
      }
      return 'Elastic Compute Cloud';
    case 'AmazonEC2(RIFee)':
      if (short) {
        return 'EC2(RI Fee)';
      }
      return 'Elastic Compute Cloud(RI Fee)';
    case 'AmazonCloudFront':
      return 'CloudFront';
    case 'AWSCloudTrail':
      return 'CloudTrail';
    case 'AmazonCloudWatch':
      return 'CloudWatch';
    case 'AWSConfig':
      return 'Config';
    case 'AWSDataTransfer':
      return 'Data Transfer';
    case 'AWSDirectoryService':
      return 'Directory Service';
    case 'AmazonDynamoDB':
      return 'DynamoDB';
    case 'AmazonECR':
      return 'EC2 Container Registry (ECR)';
    case 'AmazonElastiCache':
      return 'ElastiCache';
    case 'AmazonElastiCache(RIFee)':
      return 'ElastiCache(RI Fee)';
    case 'AmazonES':
      return 'Elasticsearch';
    case 'awskms':
      return 'Key Management Service';
    case 'AmazonKinesis':
      return 'Kinesis';
    case 'AWSLambda':
      return 'Lambda';
    case 'AmazonRDS':
      if (short) {
        return 'RDS';
      }
      return 'RDS Service';
    case 'AmazonRDS(RIFee)':
      return 'RDS Service(RI Fee)';
    case 'AmazonRekognition':
      return 'Rekognition';
    case 'AmazonRedshift':
      return 'Redshift';
    case 'AmazonRoute53':
      return 'Route 53';
    case 'AmazonSES':
      return 'Simple Email Service';
    case 'AmazonSNS':
      return 'Simple Notification Service';
    case 'AWSQueueService':
      return 'Simple Queue Service';
    case 'AmazonS3':
      return 'Simple Storage Service';
    case 'AmazonSimpleDB':
      return 'SimpleDB';
    case 'AWSSupportDeveloper':
      return 'Support (Developer)';
    case 'AmazonVPC':
      return 'Virtual Private Cloud';
    case 'awswaf':
      return 'WAF';
    case 'AmazonWorkDocs':
      return 'WorkDocs';
    case 'AmazonCloudSearch':
      return 'CloudSearch';
    case 'OCBPremiumSupport':
      return 'PremiumSupport';
    case '_ACCOUNT_TAX':
      return '徴収される消費税(日本)';
    case '_ACCOUNT_TOTAL':
      return 'アカウント小計';
    default:
      return name;
  }
}
